/**
 * При входе в позицию бэкенд часто отдаёт имя вида «Мунира Context».
 * В шапке показываем только имя человека.
 */
export function displayUserName(name?: string | null): string {
  if (!name) return '';
  return name.replace(/\s+(Context|Контекст)$/i, '').trim();
}
